import React, {useState} from 'react';
import {Link} from "react-router-dom";
import {CheckRoute, TouristServicesListRoute} from "../../routesConstants";
import moment from "moment/moment";
import {Table} from "react-bootstrap";
import numberFormat from "../../../helpers/numberFormat";

const tempValue = {
  startDate: moment().subtract(2, 'months'),
  endDate:moment()
}
const other = {
  key: 'otherQuery',
  value:{
    startDate: tempValue.startDate.format('DD.MM.YYYY'),
    endDate: tempValue.endDate.format('DD.MM.YYYY')
  }}

const keyTransl = {
  "totalBadCounterparty": {name:'Неккоректные по покупателю касса', url:CheckRoute, toStorage: other},
  "totalBadServiceItem": {name:'Неккоректные по услугам касса', url:CheckRoute,toStorage: other},
  "unpaidOrders": {name:'Неоплаченных услуг', url:CheckRoute,toStorage: other},
  "iWay": {name:'Нужно разнести в iWay', url:TouristServicesListRoute +'#iWay'},
  "rateHawk": {name:'Нужно разнести в RateHawk', url:TouristServicesListRoute+'#sink'},
  "rateHawkCanceled": {name:'Отмененные в RateHawk', url:TouristServicesListRoute+'#sink'},
  "servicesNotFound": {name:'Нет трат за услуги в кассе', url: TouristServicesListRoute,toStorage:{key: 'tSQuery',
      value:{foundInCash:false,
        issueDate:[tempValue.startDate.format('DD.MM.YYYY HH:mm'),
          tempValue.endDate.format('DD.MM.YYYY HH:mm')]}} }
}

const AllInfoItem = ({data, item}) => {
  const [show, setShow] = useState(false)
  const isNum = typeof data[item] === 'number'
  const value = isNum ? data[item] : data[item].lengthValue
  return (
    <>
      <div
        className={`d-flex justify-content-between align-items-center gap-2  ${ value > 0 ? 'serviceCardError' : 'serviceCard'}`}>
        <div>
          {!isNum && value > 0 ?
            <i className={`fa fa-chevron-${show ? 'up' : 'down'}`} onClick={() => setShow(!show)}/> : ''}
        </div>
        <Link to={keyTransl[item].url}
              onClick={() => {
                if(keyTransl[item].toStorage){
                  localStorage.setItem(keyTransl[item].toStorage.key, JSON.stringify(keyTransl[item].toStorage.value))
                }
              }}
              target={'_blank'}
              className={'d-flex justify-content-between align-items-center w-100'}
        >
          <div>{keyTransl[item].name}</div>
          <div>{value} {!isNum && <>(<b>{numberFormat(data[item].summ)}</b>)</>}</div>

        </Link>
      </div>
      {show && <>
        {data[item].diffSumm > 0 ? <div className={'p-2'}>Разница сумм в отличающихся: <b>{numberFormat(data[item].diffSumm)}</b></div>:''}
        <Table bordered>
        <thead>
        <tr>
          <th>Дата</th>
          <th>Номер</th>
        </tr>
        </thead>
        <tbody>
        {data[item].info.map((v, i)=>{
          return <React.Fragment key={i}>
            <tr key={i}>
              <td>{v.createdAt}</td>
              <td>{v.mainPax}</td>
            </tr>
            <tr key={i} style={{borderBottom: '1px solid'}}>
              <td>{v.orderId}</td>
              <td>{numberFormat(+v.amount_payable)}{!!v.summCurrency ? `/${numberFormat(+v.summCurrency)}(K)` : ''}</td>
            </tr>
          </React.Fragment>
        })}
        </tbody>
        </Table>
      </>}
    </>

  );
};

export default AllInfoItem;
